import Header from '../modules/components/header';
import Anchors from '../modules/components/anchors';
import Menu from '../modules/components/menu';
import ScrollToTop from '../modules/components/scroll-top';

function entry() {
  new Header('.site-header', 150, 'sticky');
  new Menu({ menu: '.header__menu', toggle: '.site-menu-toggle', close: null });

  new Anchors();

  new ScrollToTop('.site-scroll-top', 300);
}

window.addEventListener('DOMContentLoaded', entry);
